// extracted by mini-css-extract-plugin
var _1 = "Attachments_content__N4sLl";
var _2 = "Attachments_contentError__5Hhkf";
var _3 = "Attachments_contentPdf__uDYpS";
var _4 = "Attachments_toggleButton__Pv0eK";
export { _1 as "content", _2 as "contentError", _3 as "contentPdf", _4 as "toggleButton" }
